module.exports = __webpack_public_path__ + "static/media/procedimiento.13145db5.pdf";